import { render, staticRenderFns } from "./choose-milestone.vue?vue&type=template&id=27d5cee0&scoped=true"
import script from "./choose-milestone.vue?vue&type=script&lang=js"
export * from "./choose-milestone.vue?vue&type=script&lang=js"
import style0 from "./choose-milestone.vue?vue&type=style&index=0&id=27d5cee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d5cee0",
  null
  
)

export default component.exports